import { GridOption, SeriesOption } from "../utils/models";

export class ChartConfig {
    protected readonly defaultColors: string[] = ['#0082C6', '#3BB8A3', '#FF5F1F', '#FFC527', '#614BC3'];
}